// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2sacE","unreadBadge":"styles_unreadBadge__2viq-","modalContent":"styles_modalContent__391ZD","modal":"styles_modal__ZTHCD"};